//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAllLabelList, handleDelLabel } from "@/api/managementCenter/labelManage";
export default {
  name: "leftLabelList",
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      keywords: "",
      curItem: "",
      list: []
    };
  },
  mounted: function mounted() {
    this.getLabelListFn();
  },
  computed: {
    labelList: function labelList() {
      var _this = this;

      var arr;

      if (this.keywords) {
        arr = this.list.filter(function (item) {
          return item.labelName.indexOf(_this.keywords) > -1;
        });
      } else {
        arr = this.list;
      }

      return arr;
    }
  },
  methods: {
    handleAdd: function handleAdd() {
      this.$emit("leftLabelClick", "addLabel", null);
    },
    getLabelListFn: function getLabelListFn() {
      var _this2 = this;

      this.loading = true;
      getAllLabelList().then(function (_ref) {
        var data = _ref.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.list = data.data || [];
          _this2.keywords = "";

          if (_this2.list.length) {
            _this2.switchItemFn(_this2.list[0]);
          } else {
            _this2.switchItemFn({});
          }
        } else {
          _this2.$message.warning(data.msg || "获取标签失败！");
        }
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    switchItemFn: function switchItemFn(item) {
      this.curItem = item.labelId;
      this.$emit("leftLabelClick", "memberList", item);
    },
    handleCommand: function handleCommand(type, item) {
      if (type == "del") {
        this.handleDelFn(item.labelId);
      } else {
        this.curItem = item.labelId;
        this.$emit("leftLabelClick", type, item);
      }
    },
    // 删除
    handleDelFn: function handleDelFn(id) {
      var _this3 = this;

      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.deleteHttp(id);
      }).catch(function () {
        _this3.$message.info("已取消删除");
      });
    },
    deleteHttp: function deleteHttp(id) {
      var _this4 = this;

      this.loading = true; // 删除接口

      handleDelLabel(id).then(function (_ref2) {
        var data = _ref2.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.$message.success("删除成功!");

          _this4.getLabelListFn();
        } else {
          _this4.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function () {
        _this4.loading = false;

        _this4.$message.error("删除异常!");
      });
    }
  }
};